import { render, staticRenderFns } from "./MissionProfileLivingSituation.vue?vue&type=template&id=12a452a6&scoped=true&"
import script from "./MissionProfileLivingSituation.vue?vue&type=script&lang=js&"
export * from "./MissionProfileLivingSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a452a6",
  null
  
)

export default component.exports